import React, { useState, useEffect, useMemo } from 'react'
import { createUser } from "@api/usersController";
import { useBranches } from "@api";
import { useUser } from "@auth/UserContext";
import { Modal, Button } from "@components";
import { toast } from "@components/toast/Toast";
import TeamMemberForm from '../forms/TeamMemberForm';
import { useForm } from 'react-hook-form';

const AddTeamMember = ({open, onClose, onComplete, roles}) => {

  const { user } = useUser();
  const [loading, setLoading] = useState(false);
  const { data: branchesData = [] } = useBranches();

  const { control, handleSubmit, setValue, reset, watch, formState: { errors, isValid }, clearErrors, setError } = useForm({
    defaultValues: {
      name: "",
      email: "",
      roleId: "",
      branchId: "",
    }
  });

  // Memoize branches for the form
  const branches = useMemo(() => {
    const mappedBranches = branchesData.map(x => ({
      value: x.id ?? "",
      display: x.name,
    }));
    
    return mappedBranches;
  }, [branchesData]);

  const onSubmit = async (values) => {
    setLoading(true);
    const success = await addTeamMember(values);
    setLoading(false);
    
    if (success) {
      toast({ description: `Added "${values.name}" as a team member` });
      onComplete()
      handleClose()
    }
  };

  const addTeamMember = async (values) => {
    let response = await createUser(
      values.name,
      values.email,
      values.branchId || null,
      values.roleId,
    );
 
    if (response.error === "duplicate") {
      setError("email", { type: "custom", message: "This email address has already been used" });
      return false;
    }
    return true
  }

  const handleClose = () => {
    reset();
    clearErrors()
    onClose();
  }

  return (
    <Modal isOpen={open} onClose={handleClose} title="Add team member" size="sm">
      <div className="p-5">
        <TeamMemberForm 
          handleSubmit={handleSubmit}
          onSubmit={onSubmit}
          control={control}
          errors={errors}
          branches={branches}
          roles={roles}
          hasBranches={!!branches}
        />
      </div>
      <div className="p-4 flex gap-2 justify-end border-t">
        <Button onClick={handleClose} disabled={loading} color="secondary">Cancel</Button>
        <Button 
          type="submit" 
          onClick={handleSubmit(onSubmit)} 
          color="primary" 
          disabled={!isValid}
          submitting={loading}
        >Add team member</Button>
      </div>
    </Modal>
  )
}

export default AddTeamMember